import personalwebsite from "../../assets/projectDemo/personal.png"
import realstate from "../../assets/projectDemo/realstate.png"
import ecommerce from "../../assets/projectDemo/ecom2.png"
import ecommerceweb from "../../assets/projectDemo/ecomm.png"
import ecommerce2 from "../../assets/projectDemo/Ecom.png"
import coffeeweb from "../../assets/projectDemo/coffee.png"
import spotify from "../../assets/projectDemo/spotify clone.png"
import todoapp from "../../assets/projectDemo/todo.png"
import weatherapp from "../../assets/projectDemo/weatherapp.png"
import loginpage from "../../assets/projectDemo/login.png"








export const projectsData = [
    {
        id: 1,
        image: personalwebsite,
        title: 'Personal website',
        category: 'Web',
        link: 'https://pemahojer.com.np/',
    },
    {
        id: 2,
        image: realstate,
        title: 'Real Estate Website',
        category: 'Web',
        link: 'https://real-state-nepal-gzgj9y18b-pema-wosers-projects.vercel.app/',
    },
    {
        id: 3,
        image: ecommerce,
        title: 'Ecommerce Website',
        category: 'Web',
        link: ecommerce,
    },
    {
        id: 4,
        image: ecommerce2,
        title: 'Ecommerce Website',
        category: 'Web',
        link: ecommerce2,
    },
    {
        id: 8,
        image: ecommerceweb,
        title: 'Ecommerce Website',
        category: 'Web',
        link: 'https://ecommerce-web-swart.vercel.app/',
    },
    {
        id: 5,
        image: coffeeweb,
        title: 'Figma CoffeeWeb',
        category: 'design',
        link: coffeeweb,
    },
    {
        id: 6,
        image: spotify,
        title: 'Spotify Using Figma',
        category: 'design',
        link: spotify,
    },
    {
        id: 7,
        image: todoapp,
        title: 'ToDo App ',
        category: 'app',
        link: todoapp,
    },
    {
        id: 7,
        image: weatherapp,
        title: 'Weather App',
        category: 'app',
        link: weatherapp,
    },
    {
        id: 8,
        image: loginpage,
        title: 'Login Page html/css',
        category: 'Web',
        link: loginpage,
    },
];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'Web',
    },
    {
        name: 'app',
    },
    {
        name: 'design',
    },
    
]